import { isArray } from "lodash";

import type { TagProps } from "@sol/uikit/data-display/Tag/Tag";

import { UserRole } from "../users";

const { TRAINER, TUTOR } = UserRole;

const getRole = (roles: UserRole | UserRole[]) => (isArray(roles) ? roles[0] : roles);
export const getTagVariant = (roles: UserRole | UserRole[]): TagProps["color"] => {
    const role = getRole(roles);
    switch (role) {
        case TRAINER:
            return "blue";
        case TUTOR:
            return "orange";
    }
};
